export default __webpack_public_path__ + "static/media/lamp-gray-full.61e31f4b.svg";